import {
  ChangeDetectionStrategy,
  Component,
  Output,
  EventEmitter,
  AfterViewInit,
  OnInit,
  Inject,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import {AuthConfig, JwksValidationHandler, OAuthErrorEvent, OAuthService} from "angular-oauth2-oidc";
import {SsoConfigModel} from "./modules/authentication/models/sso-config.model";
import {filter} from "rxjs";
import {SocialOauthRedirectService} from "./modules/authentication/angular/services/social-oauth-redirect.service";
import {PostLoginRedirectService} from "./modules/authentication/angular/services/post-login-redirect.service";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'bootstrap',
  template: '',
})
export class BootstrapAngularComponent implements AfterViewInit, OnChanges {

  constructor(@Inject(OAuthService) private oauthService: OAuthService,
              @Inject(SocialOauthRedirectService) private socialOauthRedirectService: SocialOauthRedirectService,
              @Inject(PostLoginRedirectService) private postLoginRedirectService: PostLoginRedirectService) {
    // Handle a pending Google/Microsoft OAuth redirect callback, if any - independent
    // of the ssoConfig-gated Auth0 flow below.
    this.socialOauthRedirectService.tryHandleCallback();
  }

  @Input() ssoConfig: SsoConfigModel;
  @Output() public initialized: EventEmitter<void> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ssoConfig) {
      if (this.ssoConfig?.enabled) {
        this._setSsoConfig(this.ssoConfig);
      }
    }
  }

  public ngAfterViewInit(){
    this.initialized.emit();
  }

  private _setSsoConfig(ssoConfig: SsoConfigModel) {
    const authCodeFlowConfig: AuthConfig = {
      // Url of the Identity Provider
      // issuer: this.config.baseAuthUrl,

      // // Omit the issuer to avoid the .well-known discovery process
      // loginUrl: 'https://pepsico-testing.us.auth0.com/authorize',  // Authorization endpoint
      // tokenEndpoint: 'https://pepsico-testing.us.auth0.com/oauth/token', // Token endpoint
      // userinfoEndpoint: 'https://pepsico-testing.us.auth0.com/oauth/userinfo', // User info endpoint

      // issuer: 'https://pepsico-testing.us.auth0.com/',
      issuer: `${ssoConfig.baseAuthUrl}/`,

      // URL of the SPA to redirect the user to after login
      redirectUri: window.location.origin + '/token',

      postLogoutRedirectUri: window.location.origin + '/login',

      // URL of the SPA to redirect the user after silent refresh
      silentRefreshRedirectUri: window.location.origin + '/silent-refresh',
      useSilentRefresh: true,
      // logoutUrl: `${ssoConfig.baseAuthUrl}/logout`,

      clientId: ssoConfig.clientId,
      responseType: 'code',
      oidc: true,
      requireHttps: false, // TODO REMOVE ITS FOR TESTING
      scope: ssoConfig.authScope,
      customQueryParams: {
        audience: ssoConfig.audience,
      },
      showDebugInformation: true,
    };
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.setStorage(localStorage);

    // For debugging:
    this.oauthService.events.subscribe(e => e instanceof OAuthErrorEvent ? console.error(e) : console.warn(e));

    // // Load information from Auth0 (could also be configured manually)
    // this.oauthService.loadDiscoveryDocument()
    //
    //   // See if the hash fragment contains tokens (when user got redirected back)
    //   .then(() => this.oauthService.tryLoginCodeFlow())
    //
    //   // If we're still not logged in yet, try with a silent refresh:
    //   .then(() => {;
    //     if (!this.oauthService.hasValidAccessToken()) {
    //       return this.oauthService.silentRefresh();
    //     } else {
    //       console.log('HAS TOKEN!!!!!')
    //     }
    //   })
    //
    //   // Get username, if possible.
    //   .then(() => {
    //     if (this.oauthService.getIdentityClaims()) {
    //       // const username = this.oauthService.getIdentityClaims()['name'];
    //       const user = this.oauthService.getIdentityClaims();
    //       console.log(user);
    //     }
    //   })
    //   .catch((error) => {
    //
    //   })

    // Always load the discovery document, even if we already have a valid session:
    // it's what populates the OAuth library's loginUrl, which the SSO login button's
    // initCodeFlow() needs to actually navigate. Skipping it left the button silently
    // waiting on a 'discovery_document_loaded' event that would never come whenever a
    // still-valid token happened to be present on landing on the login page.
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
      // Check if the user has a valid access token
      if (this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken()) {
        // The user is logged in, set up silent refresh
        this.oauthService.setupAutomaticSilentRefresh();

        // Landed back here from the SSO redirect (initCodeFlow's redirectUri). A plain
        // $state.go races the app's permission/user-info resolution, which isn't warmed
        // up yet this early - do a full navigation so the app reboots the same way it
        // does on any normal reload while already logged in.
        if (window.location.pathname === '/token') {
          this.postLoginRedirectService.navigateToPostLoginUrl();
        }
      } else if (window.location.pathname === '/token') {
        // Landed back on the callback route but the exchange didn't produce a valid
        // session (e.g. the user denied consent) - send them back to login with a
        // visible error instead of leaving them stuck on the "Loading..." page.
        console.error('[SSO] callback did not yield a valid session');
        this.postLoginRedirectService.navigateToLoginWithError();
      }
    }).catch(err => {
      console.error('[SSO] loadDiscoveryDocumentAndTryLogin failed', err);
      if (window.location.pathname === '/token') {
        this.postLoginRedirectService.navigateToLoginWithError();
      }
    });

    // subscribe to token events
    this.oauthService.events.pipe(filter((e: any) => {
      console.log("e : ", e);
      return e.type === 'token_received';
    })).subscribe(() => {
      console.log("here..");
    });

    // this.oauthService.loadDiscoveryDocumentAndTryLogin().then(isLoggedIn => {
    //   console.log("isLoggedIn: ", isLoggedIn);
    //   if (isLoggedIn) {
    //     const token = this.oauthService.getAccessToken();
    //     this.oauthService.setupAutomaticSilentRefresh();
    //   } else {
    //     // this.oauthService.initCodeFlow();
    //   }
    // });
  }
}
